// 由于淘特采取的全表单动态渲染，有些复杂的表单控件层级也许会很深
// 且有可能控件间需要互相影响
// 所以将淘特的表单数据采用vuex来管理
import {data2form} from '@/components/prod/center/components/TJBInfoForm/utils/data'
import { getTaoTeDetail } from '@/servers/prod/center/tjb';

const tjbForm = {
  state: () => ({
    form: {
      categoryIds: []
    }, // 当前淘特表单
    oriData: {}, // 原数据，detail接口返回的数据
    // 目前后端对一些选项的接口未提供搜索分页功能，
    // 采取前端搜索分页
    optionsMap: {},
    initTJbDetail: {}
  }),
  mutations: {
    setTJbDetail(state, detail) {
      state.initTJbDetail = detail
    },
    updateForm(state, newFormFields) {
      state.form = {
        ...state.form,
        ...newFormFields
      }
    },
    setForm(state, newForm) {
      state.form = {
        ...newForm,
        categoryIds: state.form.categoryIds
      }
    },
    setOriData(state, data) {
      state.oriData = data
    },
    clear(state) {
      state.form = {
        categoryIds: []
      }
      state.oriData = {}
      state.optionsMap = {}
    },
    initOptions(state, {key, options}) {
      state.optionsMap[key] = options
    }
  },
  actions: {
    async getInitTJbDetail({commit}, data) { 
      const res = await getTaoTeDetail(data);
      commit('setTJbDetail', res);
    },
    initTjbData ({commit, dispatch, state, rootGetters}, data) {
      commit("setOriData", data)
      // 对data进行转换更新到form
      let form = data2form(data, state.form)
      if (rootGetters.removePureItem) {
        form.pureType = data.pureType;
      }
      if (state.form.categoryIds.length) {
        delete form.categoryIds
      }
      dispatch("updateTjbForm", form)
    },
    initTjbForm ({commit}, form) {
      commit("setForm", form)
    },
    updateTjbForm ({commit}, newFormFields) {
      commit("updateForm", newFormFields)
    },
    clearTjbForm_PData ({commit, state}) {
      // 清空所有p-的数据
      const voidObj = {}
      Object.keys(state.form).forEach(element => {
        if (/^p-/.test(element) && !/-sizeGroup$/.test(element)) {
          if (state.form[element] && !state.form[element][0].valueId) {
            // 输入框的类型
            voidObj[element] = JSON.parse(JSON.stringify(state.form[element]))
            voidObj[element][0].valueName = ""
            return ;
          }
          voidObj[element] = ''
        }
      });
      commit("updateForm", voidObj)
    },
    clearTjbInfo({commit}) {
      commit("clear")
    },
    initTjbOptions({commit}, data) {
      commit("initOptions", data)
    }
  },
  getters: {
    tjbForm(state) {
      return state.form
    },
    tjbData(state) {
      return state.oriData
    },
    tjbOptions: (state) => ({key, search}) => {
      if (!state.optionsMap[key]) return false
      return state.optionsMap[key].filter(op => op.displayName.indexOf(search) > -1).slice(0,99)
    }
  }
}

export default tjbForm
